import React, { useState, useEffect } from 'react';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import Select, { components } from 'react-select';
import { showToast } from '../toastUtils';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSort, faSortUp, faSortDown } from '@fortawesome/free-solid-svg-icons';
import { queuedApiFetch, apiFetch } from '../api';

function SubmissionStatus() {
  //const powerBiUrl = "https://app.powerbi.com/reportEmbed?reportId=9818f0ac-1cd1-40e1-bc87-0662cb045596&autoAuth=true&ctid=b161c897-0ae2-42a0-be86-8f7e36f2049f";
  const columnOptions = [
    'Sno', 'Proj_Name', 'CPRS_Number', 'Proj_Approved_Budget', 'Proj_Manager_Name',
    'Consultant_Names', 'Consultant_Appointment_Date', 'Detailed_Design_and_Auth_Submns', 'Prep_of_Procurement_of_Main_Contract', 'OpenTender_and_Award_of_Main_Contract',
    'Construction_works_Start', 'Construction_works_End', 'Handover_Date', 'Remarks'
  ];

  const getUserDetails = localStorage.getItem('userDetails');
  const userDetails = getUserDetails ? JSON.parse(getUserDetails) : '';  
  const getUserAccess = userDetails ? userDetails.access_level : '';
  const [rows, setRows] = useState([]);
  const [selectedColumns, setSelectedColumns] = useState(columnOptions);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
    const [sortDirection, setSortDirection] = useState('asc'); 
  
    const handleSort = () => {
      const newSortDirection = sortDirection === 'asc' ? 'desc' : 'asc';
      setSortDirection(newSortDirection);
  
      const sortedRows = [...rows].sort((a, b) => {
        const projNameA = a.Proj_Name.toLowerCase();
        const projNameB = b.Proj_Name.toLowerCase();
  
        if (newSortDirection === 'asc') {
          return projNameA.localeCompare(projNameB); // Ascending order
        } else {
          return projNameB.localeCompare(projNameA); // Descending order
        }
      });
  
      setRows(sortedRows);
    };

  // const fetchWBSData = () => {
  //   setIsLoading(true)
  //   const requestOptions = {
  //     method: 'GET',
  //     //headers: new Headers({ 'ngrok-skip-browser-warning': '69420' })
  //   };

  //   queuedApiFetch('/project/get_submission_status', requestOptions)
  //     .then((response) => response.json())
  //     .then((data) => {
  //       if (data.apistatus.Status_Code === 200 && data.apistatus.Status_Description.toLowerCase() === 'success') {
  //         setRows(data.data);
  //         setIsLoading(false);
  //       }
  //     })
  //     .catch((error) => console.error('Error fetching data:', error))
  //     .finally(() => setIsLoading(false));
  // };

  const fetchWBSData = async () => {
    setIsLoading(true);
  
    const requestOptions = {
      method: 'GET',
      //headers: new Headers({ 'ngrok-skip-browser-warning': '69420' })
    };
  
    try {
      const response = await queuedApiFetch(`/project/get_submission_status`, requestOptions);
      const data = await response;
  
      if (data.apistatus.Status_Code === 200 && data.apistatus.Status_Description.toLowerCase() === 'success') {
        setRows(data.data);
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setIsLoading(false);
    }
  };
  
  useEffect(() => {
    fetchWBSData();
  }, []);

  // const handleExport = async () => {
  //   const workbook = new ExcelJS.Workbook();
  //   const worksheet = workbook.addWorksheet('Projects');    
  //   worksheet.columns = selectedColumns.map(column => {
  //     const header = column.replace(/_/g, ' ').toUpperCase();
  //     return { header, key: column };
  //   });    
  //   rows.forEach(row => {
  //     const rowData = {};
  
  //     selectedColumns.forEach(column => {
  //       let value = row[column] || '';        
  //       const dateValue = new Date(value);                
  //       if (value && !isNaN(dateValue.getTime()) && typeof value === 'string' && value.trim() !== '' && /\d{4}-\d{2}-\d{2}/.test(value)) {          
  //         rowData[column] = dateValue.toLocaleDateString('en-US');
  //       } else {          
  //         rowData[column] = value;
  //       }
  //     });      
  //     worksheet.addRow(rowData);
  //   });    
  //   workbook.xlsx.writeBuffer().then(buffer => {
  //     saveAs(new Blob([buffer]), 'SubmissionStatusList.xlsx');
  //   });
  // };
  
  const handleExport = async () => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Export');    
  
    const orderedColumns = selectedColumns.includes('Sno')
      ? ['Sno', ...selectedColumns.filter(col => col !== 'Sno')]
      : selectedColumns;
  
    worksheet.columns = orderedColumns.map(column => {
      const header = labelMapping[column] || column.replace(/_/g, ' ').toUpperCase();
      return { header, key: column };
    });
  
    // Initialize auto-increment counter for "Sno"
    let snoCounter = 1;
  
    rows.forEach(row => {
      const rowData = {};
  
      orderedColumns.forEach(column => {
        if (column === 'Sno') {
          // Set auto-incremented value for "Sno"
          rowData[column] = snoCounter++;
        } else {
          let value = row[column] || '';
          const dateValue = new Date(value);
  
          if (
            value && !isNaN(dateValue.getTime()) &&
            typeof value === 'string' && value.trim() !== '' &&
            /\d{4}-\d{2}-\d{2}/.test(value)
          ) {
            // Format dates to dd-mm-yyyy
            const day = String(dateValue.getDate()).padStart(2, '0');
            const month = String(dateValue.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
            const year = dateValue.getFullYear();
            rowData[column] = `${day}-${month}-${year}`;
          } else if (
            ['Proj_Approved_Budget',].includes(column) &&
            typeof value === 'number'
          ) {
            // Format currency columns as $XXX,XXX.00
            rowData[column] = new Intl.NumberFormat('en-US', {
              style: 'currency',
              currency: 'USD',
              minimumFractionDigits: 0,
              maximumFractionDigits: 0
            }).format(value);
          } else {
            // Other columns
            rowData[column] = value;
          }
        }
      });
  
      worksheet.addRow(rowData);
    });
  
    // Export to Excel file
    workbook.xlsx.writeBuffer().then(buffer => {
      saveAs(new Blob([buffer]), 'SubmissionStatusList.xlsx');
    });
  };

  const labelMapping = {
    Sno: 'S.No',
    Proj_Name: 'Project Name',
    CPRS_Number: 'CPRS Number',
    Proj_Approved_Budget: 'Project Approved Budget',
    Proj_Manager_Name: 'Project Manager Name',
    Consultant_Names: 'Consultant Names',
    Consultant_Appointment_Date: 'Consultant Appointment Date',
    Detailed_Design_and_Auth_Submns: 'Detailed Design and Authority Submissions',
    Prep_of_Procurement_of_Main_Contract: 'Preparation of Procurement of Main Contract',
    OpenTender_and_Award_of_Main_Contract: 'Open Tender and Award of Main Contract',
    Construction_works_Start: 'Construction works Start',
    Construction_works_End: 'Construction works End',
    Handover_Date: 'Handover Date',
    Remarks: 'Remarks'
};


  // const options = [
  //   { value: 'selectAll', label: 'Select All' },
  //   ...columnOptions.map(column => ({
  //     value: column,
  //     label: column.replace(/_/g, ' ').toUpperCase()
  //   }))
  // ];

  const options = [
    { value: 'selectAll', label: 'Select All' },
    ...columnOptions.map(column => ({
      value: column,
      label: labelMapping[column] || column.replace(/_/g, ' ').toUpperCase()
    }))
  ];

  const handleColumnChange = (selectedOptions) => {
    if (selectedOptions.some(option => option.value === 'selectAll')) {
      if (selectedColumns.length < columnOptions.length) {
        setSelectedColumns(columnOptions); // Select all columns
      } else {
        setSelectedColumns([]); // Deselect all columns
      }
    } else {
      setSelectedColumns(selectedOptions.map(option => option.value));
    }
  };

  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      width: '100%',  // Adjust width as needed
      borderColor: state.isFocused ? '#B0B0B0' : '#E0E0E0',  // Light gray border color on focus
      borderRadius: '8px',
      padding: '5px',
      boxShadow: state.isFocused ? '0 0 5px rgba(176, 176, 176, 0.5)' : 'none', // Light gray focus box-shadow
    }),
    menu: (provided) => ({
      ...provided,
      marginTop: '5px',
      borderRadius: '8px',
      boxShadow: '0 4px 8px rgba(0, 0, 0, 0.05)', // Lighter shadow
    }),
    option: (provided, state) => ({
      ...provided,
      padding: '10px',
      backgroundColor: state.isSelected ? '#B0B0B0' : state.isFocused ? '#F8F8F8' : '#fff', // Lighter gray background when selected
      color: state.isSelected ? '#fff' : '#333', // White text on selected
      borderRadius: '4px',
      cursor: 'pointer',
      ':active': {
        backgroundColor: '#B0B0B0', // Active state lighter gray background
        color: '#fff',
      },
    }),
    multiValue: (provided) => ({
      ...provided,
      backgroundColor: '#B0B0B0',  // Lighter gray background for multi-value
      borderRadius: '4px',
      color: '#fff',
    }),
    multiValueLabel: (provided) => ({
      ...provided,
      color: '#fff',
    }),
    multiValueRemove: (provided) => ({
      ...provided,
      color: '#fff',
      ':hover': {
        backgroundColor: '#D3D3D3',  // Lighter gray color for remove icon hover
      },
    }),
  };

  const handleEditField = (index, field, value) => {
    const updatedRows = [...rows];
    updatedRows[index][field] = value;
    setRows(updatedRows);
  };

  // const SubmissionStatusList = () => {
  //   setSubmitLoading(true);
  //   if (!submitLoading) {
  //     const sendData = rows;
  //     const requestOptions = {
  //       method: 'POST',
  //       headers: {
  //         'Content-Type': 'application/json',
  //         'ngrok-skip-browser-warning': '69420'
  //       },
  //       body: JSON.stringify(sendData),
  //     };
  //     queuedApiFetch('/project/update_submission_status', requestOptions)
  //       .then((response) => response.json())
  //       .then((result) => {
  //         // alert(result.message || 'Data saved successfully');
  //         showToast.success('Data saved successfully');
  //         setSubmitLoading(false);          
  //       })
  //       .catch((error) => console.error('Error saving data:', error));
  //   }
  // };   
  
  const SubmissionStatusList = async () => {
    // Prevent multiple submissions while the request is in progress
    if (submitLoading) return;
  
    setSubmitLoading(true);
  
    const sendData = rows;
    const requestOptions = {
      method: 'POST',
      // headers: {
      //   'Content-Type': 'application/json',
      //   'ngrok-skip-browser-warning': '69420',
      // },
      body: JSON.stringify(sendData),
    };
  
    try {
      const response = await queuedApiFetch(`/project/update_submission_status`,
        requestOptions
      );
      const result = await response;
  
      // Handle the success response
      if (result.apistatus.Status_Code === 200 && result.apistatus.Status_Description.toLowerCase() === 'success') {
        showToast.success('Data saved successfully');
      } else {
        showToast.error(result.apistatus.Status_Description || 'Error occurred. Please try again.');
      }
    } catch (error) {
      console.error('Error saving data:', error);
      showToast.error('Something went wrong. Please try again.');
    } finally {
      // Reset the loading state after the request completes
      setSubmitLoading(false);
    }
  };
  
  const CustomValueContainer = ({ children, ...props }) => {
    const selectedOptions = props.getValue();

    let displayValue;
    if (selectedOptions.length <= 2) {      
      displayValue = selectedOptions.map(opt => opt.label).join(', ');
    } else {      
      const displayedLabels = selectedOptions.slice(0, 2).map(opt => opt.label);
      const moreCount = selectedOptions.length - 2;
      displayValue = `${displayedLabels.join(', ')} + ${moreCount} more`;
    }

    return (
      <components.ValueContainer {...props}>
        <span>{displayValue}</span>
        {children[1]}
      </components.ValueContainer>
    );
  };
  
  const CustomOption = (props) => {
    return (
      <components.Option {...props}>
        <input
          type="checkbox"
          checked={props.isSelected}
          onChange={() => null}
          style={{ marginRight: 8 }}
        />
        <label>{props.label}</label>
      </components.Option>
    );
  };

  const formatDate = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    if (isNaN(date)) return '';    
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();    
    return `${day}-${month}-${year}`;
  };

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(amount);
  };
  
  return (
    <div className="bodywrapp" style={{width : '100%'}}>
      <div className="header" style={{ width: '90%' }}>
        <div className="projectwrap">
          <div className="addwbswrap">
            <button disabled={rows && rows.length == 0 ? true : false} onClick={handleExport}>Export</button>
          </div>
          <button id="submit" disabled={submitLoading || rows.length == 0 ? true : false} onClick={SubmissionStatusList}>Submit</button>
        </div>
      </div>

      <div>
      
      <div className="filter-wrap" style={{ width: '90%' }}>
        <Select
          isMulti
          name="columns"
          options={options}
          value={options.filter(option => selectedColumns.includes(option.value))}
          onChange={handleColumnChange}
          closeMenuOnSelect={false}
          placeholder="Select Columns"
          hideSelectedOptions={false}
          styles={customStyles}
          components={{
            ValueContainer: CustomValueContainer,
            Option: CustomOption,
          }}
        />
      </div>

        <div className="tablewrap" style={{ width: '90%', height: 'auto' }}>
          <table id="wbsTable">
            <thead>
              <tr>
                {selectedColumns.includes('Sno') && <th className="description-column">S.No</th>}
                         {selectedColumns.includes('Proj_Name') && (
                                                <th onClick={handleSort}>
                                                  Project&nbsp;Name&nbsp;&nbsp;
                                                  {sortDirection === 'asc' ? (
                                                    <FontAwesomeIcon icon={faSortUp} />
                                                  ) : (
                                                    <FontAwesomeIcon icon={faSortDown} />
                                                  )}
                                                </th>
                                              )}
                {selectedColumns.includes('CPRS_Number') && <th className="description-column">CPRS Number</th>}
                {selectedColumns.includes('Proj_Approved_Budget') && <th className="description-column">Project Approved Budget</th>}
                {selectedColumns.includes('Proj_Manager_Name') && <th className="description-column">Project Manager Name</th>}
                {selectedColumns.includes('Consultant_Names') && <th className="description-column">Consultant Names</th>}
                {selectedColumns.includes('Consultant_Appointment_Date') && <th style={{ minWidth: '100px' }} className="description-column">Consultant Appointment Date</th>}
                {selectedColumns.includes('Detailed_Design_and_Auth_Submns') && <th style={{ minWidth: '100px' }} className="description-column">Detailed Design and Authority Submissions</th>}
                {selectedColumns.includes('Prep_of_Procurement_of_Main_Contract') && <th style={{ minWidth: '100px' }} className="description-column">Preparation of Procurement of Main Contract</th>}
                {selectedColumns.includes('OpenTender_and_Award_of_Main_Contract') && <th style={{ minWidth: '100px' }} className="description-column">Open Tender and Award of Main Contract</th>}
                {selectedColumns.includes('Construction_works_Start') && <th style={{ minWidth: '100px' }} className="description-column">Construction works Start</th>}
                {selectedColumns.includes('Construction_works_End') && <th style={{ minWidth: '100px' }} className="description-column">Construction works End</th>}
                {selectedColumns.includes('Handover_Date') && <th style={{ minWidth: '100px' }} className="description-column">Handover Date</th>}
                {selectedColumns.includes('Remarks') && <th className="description-column">Remarks</th>}                
              </tr>
            </thead>
            <tbody>
              {selectedColumns.length === 0 ? (
                  <tr>
                    <td colSpan='37' style={{ textAlign: 'center', verticalAlign: 'middle', height: '100px', padding: '20px' }}>Please Select any one column</td>
                  </tr>
                )
                :
                  rows.length === 0 ? (
                    <tr>
                      <td colSpan='37' style={{ textAlign: 'center', verticalAlign: 'middle', height: '100px', padding: '20px' }}>{isLoading ? 'Loading...':'No records found'}</td>
                    </tr>
                  ) 
                  :
                  (
                    rows.map((row, index) => (
                      <tr key={index}>
                        {selectedColumns.includes('Sno') && <td>{index + 1}</td>}
                        {selectedColumns.includes('Proj_Name') && <td>{row.Proj_Name}</td>}
                        {selectedColumns.includes('CPRS_Number') && <td>{row.CPRS_Number}</td>}
                        {selectedColumns.includes('Proj_Approved_Budget') && <td>{formatCurrency(row.Proj_Approved_Budget)}</td>}
                        {selectedColumns.includes('Proj_Manager_Name') && <td>{row.Proj_Manager_Name}</td>}
                        {selectedColumns.includes('Consultant_Names') && <td>{row.Consultant_Names}</td>}
                        {selectedColumns.includes('Consultant_Appointment_Date') && <td>{formatDate(row.Consultant_Appointment_Date)}</td>}
                        {selectedColumns.includes('Detailed_Design_and_Auth_Submns') && <td>{formatDate(row.Detailed_Design_and_Auth_Submns)}</td>}
                        {selectedColumns.includes('Prep_of_Procurement_of_Main_Contract') && <td>{formatDate(row.Prep_of_Procurement_of_Main_Contract)}</td>}
                        {selectedColumns.includes('OpenTender_and_Award_of_Main_Contract') && <td>{formatDate(row.OpenTender_and_Award_of_Main_Contract)}</td>}
                        {selectedColumns.includes('Construction_works_Start') && <td>{formatDate(row.Construction_works_Start)}</td>}
                        {selectedColumns.includes('Construction_works_End') && <td>{formatDate(row.Construction_works_End)}</td>}
                        {selectedColumns.includes('Handover_Date') && <td>{formatDate(row.Handover_Date)}</td>}
                        {selectedColumns.includes('Remarks') && <td>
                          <input
                            disabled={getUserAccess == 'project_admin' ? false : true}
                            type="text"
                            value={row.Remarks}
                            onChange={(e) =>
                              handleEditField(index, 'Remarks', e.target.value)
                            }
                          />
                        </td>}
                      </tr>
                    ))
                  )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export default SubmissionStatus;
